<template>
	<div v-loading="loading" element-loading-text="获取数据中,请稍后" element-loading-spinner="el-icon-loading">
		<el-row :gutter="10">
			<el-col :xs="24" :sm="24">
				<!-- <el-card> -->
				<el-tabs v-model="activeName" @tab-click="handleClick" tab-position="top">
					<el-tab-pane name="managedata">
						<span slot="label">
							<i class="el-icon-s-order"></i>
							授权数据管理
						</span>
						<div>
							<el-card>
								<el-form inline size="small">
									<el-form-item>
										<el-select v-model="dist_name" placeholder="公司" filterable>
											<el-option v-for="item in distributorOptions" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item>
										<el-select v-model="template_name" placeholder="模版" filterable>
											<el-option v-for="item in authTemplateOptions" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
									<el-form-item>
										<el-date-picker v-model="year_range" type="year" placeholder="年份"
											value-format="yyyy">
										</el-date-picker>
									</el-form-item>
									<el-form-item>
										<el-input v-model="keywords" placeholder="医院/授权范围" maxlength="30" clearable />
									</el-form-item>
									<el-form-item>
										<el-button type="primary" plain @click="fetchData()">搜索</el-button>
										<el-button type="info" plain @click="resetSearch()">重置</el-button>
										<el-button type="success" plain @click="exportData()">导出</el-button>
										<el-divider direction="vertical"></el-divider>
										<el-button type="success" @click="openDialog()">新增授权</el-button>
										<el-button type="primary" :disabled="multipleSelection.length==0"
											@click="openDialogBatchUpdate()">批量更新</el-button>
										<el-button type="warning" :disabled="multipleSelection.length==0"
											@click="batchDownload()">批量下载</el-button>
									</el-form-item>
								</el-form>
							</el-card>
							<el-card style=" margin-top: 15px;">
								<el-table ref="multipleTable" :data="tableData" stripe style="width: 100%;"
									@selection-change="handleSelectionChange" v-loading="loading">
									<el-table-column type="selection" width="55"></el-table-column>
									<el-table-column prop="auth_distributor__dist_name" label="公司名称" width="180"
										sortable>
									</el-table-column>
									<el-table-column prop="auth_distributor__dist_area" label="区域" sortable>
									</el-table-column>
									<el-table-column prop="auth_template__template_name" label="授权模板" sortable
										width="180">
										<template slot-scope="props">
											{{props.row.auth_template__template_name}}-{{props.row.auth_template__template_remark}}
										</template>
									</el-table-column>
									<el-table-column prop="auth_range" label="授权范围" sortable width="200">
									</el-table-column>
									<el-table-column prop="auth_start_date" label="开始时间" sortable>
									</el-table-column>
									<el-table-column prop="auth_end_date" label="结束时间" sortable>
									</el-table-column>
									<el-table-column prop="auth_appendix_title" label="附件标题" show-overflow-tooltip>
									</el-table-column>
									<el-table-column prop="auth_hospital_list" label="附件医院名单" show-overflow-tooltip>
									</el-table-column>
									<el-table-column prop="for_bid_only" label="仅供招标" sortable>
										<template slot-scope="scope">
											<el-tag size="small" effect="dark"
												:type="formatBannedTags(scope.row.for_bid_only).type"
												disable-transitions>
												<i :class="formatBannedTags(scope.row.for_bid_only).class"></i>
											</el-tag>
										</template>
									</el-table-column>
									<el-table-column prop="auth_remark" label="备注">
									</el-table-column>
									<el-table-column label="更新时间" prop="update_date" sortable>
										<template slot-scope="props">
											<span>
												{{
													props.row.update_date
														.split('T')
														.slice(0, 1)
														.join('')
												}}
											</span>
										</template>
									</el-table-column>

									<el-table-column label="操作" width="180">
										<template slot-scope="scope">
											<el-button-group>
												<el-button size="mini" icon="el-icon-edit"
													@click="openDialog(scope.row)">改</el-button>
												<el-button type="danger" size="mini" icon="el-icon-delete"
													@click="deletetableData(scope.row)">删</el-button>
											</el-button-group>
										</template>
									</el-table-column>
								</el-table>
							</el-card>

							<el-pagination v-if="total > 0" @size-change="handleSizeChange"
								@current-change="handleCurrentChange" :current-page="currentPage"
								:page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
								layout="total, sizes, prev, pager, next, jumper" :total="total"
								class="paginator hidden-sm-and-down">
							</el-pagination>

							<!-- 数据操作 -->
							<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false"
								:close-on-press-escape="false" :show-close="false">
								<el-form :model="formData" :rules="rules" ref="form" :label-width="formLabelWidth"
									size="mini">
									<el-form-item label="经销商公司" prop="auth_distributor">
										<el-select v-model="formData.auth_distributor" filterable
											placeholder="请选择经销商公司">
											<el-option v-for="item in distributorOptions" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="授权模板" prop="auth_template">
										<el-select v-model="formData.auth_template" filterable placeholder="请选择授权模板">
											<el-option v-for="item in authTemplateOptions" :key="item.value"
												:label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="授权范围" prop="auth_range">
										<el-input v-model="formData.auth_range" type="textarea" clearable
											maxlength="100" autosize show-word-limit />
									</el-form-item>

									<el-form-item label="开始时间" prop="auth_start_date">
										<el-date-picker v-model="formData.auth_start_date" type="date"
											placeholder="选择日期" value-format="yyyy-MM-dd">
										</el-date-picker>
									</el-form-item>

									<el-form-item label="结束时间" prop="auth_end_date">
										<el-date-picker v-model="formData.auth_end_date" type="date" placeholder="选择日期"
											value-format="yyyy-MM-dd">
										</el-date-picker>
									</el-form-item>
									<el-form-item label="附件标题" prop="auth_appendix_title">
										<el-input v-model="formData.auth_appendix_title" type="textarea" clearable
											maxlength="50" autosize show-word-limit />
									</el-form-item>

									<el-form-item label="附件医院名单" prop="auth_hospital_list">
										<el-input v-model="formData.auth_hospital_list" type="textarea" clearable
											maxlength="1500" autosize show-word-limit />
									</el-form-item>

									<el-form-item label="仅供招标使用" prop="for_bid_only">
										<el-radio-group v-model="formData.for_bid_only" size="small">
											<el-radio-button label="true">是</el-radio-button>
											<el-radio-button label="false">否</el-radio-button>
										</el-radio-group>
									</el-form-item>

									<el-form-item label="备注" prop="auth_remark">
										<el-input v-model="formData.auth_remark" type="textarea" clearable
											maxlength="100" autosize show-word-limit />
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogVisible = false">取消</el-button>
									<el-button type="primary" @click="saveData">保存</el-button>
								</div>
							</el-dialog>

							<!-- 批量更新 -->
							<el-dialog title="批量更新日期" :visible.sync="dialogVisibleBatchUpdate"
								:close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
								<el-form :model="formDataBatch" :rules="rules_BatchUpdate" ref="formBatch"
									:label-width="formLabelWidth" size="mini">

									<el-form-item label="开始时间" prop="auth_start_date">
										<el-date-picker v-model="formDataBatch.auth_start_date" type="date"
											placeholder="选择日期" value-format="yyyy-MM-dd">
										</el-date-picker>
									</el-form-item>

									<el-form-item label="结束时间" prop="auth_end_date">
										<el-date-picker v-model="formDataBatch.auth_end_date" type="date"
											placeholder="选择日期" value-format="yyyy-MM-dd">
										</el-date-picker>
									</el-form-item>
									<el-form-item label="复制记录" prop="if_copy">
										<el-switch v-model="formDataBatch.if_copy">
										</el-switch>
									</el-form-item>

								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="dialogVisibleBatchUpdate = false">取消</el-button>
									<el-button type="primary" @click="batchUpdate()">提交</el-button>
								</div>
							</el-dialog>
						</div>
					</el-tab-pane>

					<el-tab-pane name="uploadfile">
						<span slot="label">
							<i class="el-icon-s-platform"></i>
							授权数据导入
						</span>
						<div>
							<el-card>
								<el-row :gutter="20">
									<el-col :sm="8" :xs="24">
										<el-form :disabled="isUploading">
											<el-form-item label="选择文件" :required="true">
												<el-upload action="none" class="upload-demo" ref="upload"
													:auto-upload="false" :on-change="handleFileChange"
													:on-remove="handleFileRemove" :multiple="false" accept=".xlsx"
													:file-list="fileList">
													<el-button size="small" type="primary">选择文件</el-button>
													<div slot="tip" class="el-upload__tip">只能上传 .xlsx文件</div>
												</el-upload>
											</el-form-item>
										</el-form>
										<!-- <el-button :disabled="isUploading" @click="submitUpload">导入</el-button> -->
										<el-button :disabled="isUploading" @click="submitUpload">导入</el-button>

									</el-col>
									<el-col :sm="16" :xs="24">
										<el-table :data="importResultTableData" border style="width: 100%"
											max-height="500">
											<el-table-column label="验证结果">
												<el-table-column prop="row" label="行数" width="180">
												</el-table-column>
												<el-table-column prop="error" label="问题">
												</el-table-column>
											</el-table-column>
										</el-table>
									</el-col>
								</el-row>
							</el-card>
						</div>
					</el-tab-pane>
				</el-tabs>
				<!-- </el-card> -->
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		inject: ['reload', 'logout'],
		data() {
			return {
				fileList: [],
				activeName: 'managedata', // 设置默认显示的 tab
				distributorOptions: [],
				authTemplateOptions: [],
				keywords: '',
				dist_name: '',
				year_range: '',
				template_name: '',
				tableData: [],
				total: 100,
				currentPage: 1,
				pageSize: 10,
				loading: false,
				multipleSelection: [],
				dialogVisible: false,
				dialogTitle: '新增授权记录',
				formData: {
					pk: null,
					auth_distributor: '',
					auth_template: '',
					auth_range: '',
					auth_start_date: '',
					auth_end_date: '',
					auth_hospital_list: '',
					auth_appendix_title: '',
					for_bid_only: '',
					auth_remark: ''
				},
				rules: {
					auth_distributor: [{
						required: true,
						message: '请选择经销商公司',
						trigger: 'blur'
					}],
					auth_template: [{
						required: true,
						message: '请选择模板',
						trigger: 'blur'
					}],
					auth_range: [{
						required: true,
						message: '请输入授权范围',
						trigger: 'blur'
					}],
					auth_start_date: [{
						required: true,
						message: '请选择授权开始时间',
						trigger: 'blur'
					}],
					auth_end_date: [{
						required: true,
						message: '请选择授权结束时间',
						trigger: 'blur'
					}],
				},
				formDataBatch: {
					auth_start_date: '',
					auth_end_date: '',
					if_copy: false
				},
				rules_BatchUpdate: {
					auth_start_date: [{
						required: true,
						message: '请选择授权开始时间',
						trigger: 'blur'
					}],
					auth_end_date: [{
						required: true,
						message: '请选择授权结束时间',
						trigger: 'blur'
					}],
				},
				importResultTableData: [{
					row: '',
					error: ''
				}],
				dialogVisibleBatchUpdate: false,
				formLabelWidth: '100px',
				selectedFile: null, // 用于存储用户选择的文件
				isUploading: false, // 用于在上传时禁用按钮
				loading: false
			};
		},
		methods: {
			handleClick(tab) {
				// console.log('切换到 tab:', tab.name);
			},
			handleFileChange(file, fileList) {
				this.selectedFile = file.raw; // 获取原始文件对象
				this.fileList = fileList.slice(-1);
			},
			handleFileRemove(file, fileList) {
				this.selectedFile = null; // 获取原始文件对象
			},
			//导入数据
			submitUpload() {
				let that = this;
				if (!this.selectedFile) {
					this.$message.warning('请先选择要上传的文件');
					return;
				}
				this.isUploading = true;
				const formData = new FormData();
				formData.append('file', this.selectedFile);
				that.$axios({
						url: '/apia/import/authrecord/',
						method: 'post',
						data: formData,
						headers: {
							'Content-Type': 'multipart/form-data'
						}
					})
					.then(function(res) {
						that.selectedFile = null;
						that.fileList = [];
						that.$refs.upload.clearFiles()
						if (res.data.code == '401') {
							that.importResultTableData = res.data.errors;
							that.$message({
								message: res.data.message,
								type: 'warning',
								onClose: function() {
									that.isUploading = false;
								}
							});
						} else if (res.data.code == '200') {
							// console.log(res.data.message)
							that.importResultTableData = res.data.message.errors;
							that.$message({
								message: '共读取' + res.data.total_rows + '条数据' + '，其中成功导入数据：' + res.data
									.new_records + '条，跳过重复数据：' + res.data.duplicate_records + '条。',
								type: 'success',
								onClose: function() {
									that.isUploading = false;
								}
							});
						}
						that.fetchData();
					})
					.catch(function(error) {
						that.selectedFile = null;
						that.fileList = [];
						that.$refs.upload.clearFiles()
						that.$message({
							message: error,
							type: 'warning',
							onClose: function() {
								that.isUploading = false;
							}
						});
						that.fetchData();
					});
			},
			//获取数据
			fetchData() {
				this.loading = true;
				this.$axios.get('/apia/get/authrecord/', {
					params: {
						keywords: this.keywords,
						year_range: this.year_range,
						distributor: this.dist_name,
						template: this.template_name,
						page: this.currentPage,
						page_size: this.pageSize
					}
				}).then(response => {
					if (response.data.code == '401') {
						that.logout();
					};
					this.tableData = response.data.data;
					this.total = response.data.totalItemNum;
				}).finally(() => {
					this.loading = false;
				});
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.fetchData();
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.fetchData();
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log(val)
			},
			openDialog(row = null) {
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
				});
				if (row) {
					this.dialogTitle = '修改授权记录';
					this.formData = {
						...row,
						auth_distributor: row.auth_distributor_id,
						auth_template: row.auth_template_id
					};
				} else {
					this.dialogTitle = '新增授权记录';
					this.formData = {
						pk: null,
						auth_distributor: '',
						auth_template: '',
						auth_range: '',
						auth_start_date: '',
						auth_end_date: '',
						auth_hospital_list: '',
						auth_appendix_title: '',
						for_bid_only: false,
						auth_remark: ''
					};
				}
			},
			//打开批量更新窗口
			openDialogBatchUpdate() {
				this.dialogVisibleBatchUpdate = true,
					this.$nextTick(() => {
						this.$refs.formBatch.clearValidate();
					});
				this.formDataBatch = {
					auth_start_date: '',
					auth_end_date: '',
				}
			},
			//提交批量更新
			batchUpdate() {
				let that = this;
				this.$refs.formBatch.validate((valid) => {
					if (valid) {
						let fd = new FormData();
						let formData = this.formDataBatch;
						//添加表单数据
						for (let key in formData) {
							fd.append(key, formData[key]);
						}
						const ids = this.multipleSelection.map(item => item.pk);
						fd.append('ids', ids)
						this.$axios({
								url: '/apia/batch/update/authrecord/',
								method: 'post',
								data: fd,
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							})
							.then(function(res) {
								if (res.data.code == '200') {
									that.dialogVisibleBatchUpdate = false;
									that.fetchData();
								} else {
									that.$message({
										message: res.data.message,
										type: 'warning'
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					}
				});
			},
			//保存记录
			saveData() {
				let that = this;
				this.$refs.form.validate((valid) => {
					if (valid) {
						let fd = new FormData();
						let formData = this.formData;
						//添加表单数据
						for (let key in formData) {
							fd.append(key, formData[key]);
						}
						const url = this.formData.pk ?
							'/apia/update/authrecord/' :
							'/apia/add/authrecord/';
						this.$axios({
								url: url,
								method: 'post',
								data: fd,
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							})
							.then(function(res) {
								if (res.data.code == '200') {
									that.dialogVisible = false;
									that.fetchData();
								} else {
									that.$message({
										message: res.data.message,
										type: 'warning'
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					}
				});
			},
			// 单个删除
			deletetableData(row) {
				this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						let that = this;
						let fd = new FormData();
						fd.append('pk', row.pk);
						this.$axios({
								url: '/apia/delete/authrecord/',
								method: 'post',
								data: fd,
								headers: {
									'Content-Type': 'multipart/form-data'
								}
							})
							.then(function(res) {
								if (res.data.code == 200) {
									that.fetchData();
								} else {
									that.$message({
										message: res.data.message,
										type: 'warning'
									});
								}
							})
							.catch(function(error) {
								console.log(error);
							});
					})
					.catch(() => {});
			},
			// 获取公司列表
			getDistributorOptions() {
				let that = this;
				this.$axios
					.get('/apia/list/distributor/')
					.then(function(response) {
						that.distributorOptions = response.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			// 获取模板列表
			getAuthTemplateOptions() {
				let that = this;
				this.$axios
					.get('/apia/list/authtemplate/')
					.then(function(response) {
						that.authTemplateOptions = response.data;
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			// 重置搜索
			resetSearch() {
				this.currentPage = 1;
				this.keywords = "";
				this.dist_name = "";
				this.template_name = ""
				this.year_range = "";
				this.fetchData();
			},
			//批量下载授权书
			batchDownload() {
				let that = this;
				this.loading = true;
				const ids = this.multipleSelection.map(item => item.pk);
				this.$axios.post('/apia/batch/download/authrecord/', {
					ids: ids // 用户勾选的 AuthRecord 的 ID 列表
				}, {
					responseType: 'blob' // 下载文件
				}).then(res => {
					that.loading = false;
					const blob = new Blob([res.data], {
						type: 'application/zip'
					});
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = '授权书' + Date.now() + '.zip';
					link.click();

					// a.dispatchEvent(new MouseEvent('click', {
					// 	bubbles: true,
					// 	cancelable: true,
					// 	view: window
					// }));
					// window.URL.revokeObjectURL(blob);
				});
			},
			exportData() {
				let that = this;
				that.loading = true;
				//添加表单数据
				let fileName = '经销商授权记录' + Date.now();
				this.$axios({
						url: '/apia/export/authrecord/',
						responseType: 'blob',
						method: 'get',
						data: {
							keywords: that.keywords,
							dist_name: that.dist_name,
							year_range: that.year_range,
							template_name: that.template_name,
						},
					})
					.then(function(res) {
						const _res = res.data;
						let blob = new Blob([_res], {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
						});
						let objectUrl = window.URL.createObjectURL(blob);
						let a = document.createElement('a');
						a.href = objectUrl;
						a.download = fileName.replace('.', '');
						a.dispatchEvent(new MouseEvent('click', {
							bubbles: true,
							cancelable: true,
							view: window
						}));
						that.loading = false;
						window.URL.revokeObjectURL(blob);
					})
					.catch(function(err) {
						that.loading = false;
						console.log(err);
					});

			},
			//格式化选项
			formatBannedTags(value) {
				let rlt = {};
				if (value == false) {
					rlt = {
						type: 'warning',
						class: 'el-icon-error'
					};
				} else if (value == true) {
					rlt = {
						type: 'success',
						class: 'el-icon-success'
					};
				}
				return rlt;
			},
		},
		mounted() {
			this.fetchData();
			this.getDistributorOptions();
			this.getAuthTemplateOptions();

		}
	};
</script>

<style scoped>
	.upload-demo .el-upload {
		display: inline-block;
	}
</style>